import React from 'react';
import { formatDate } from '@src/utils/time';

export interface ContentLabelProps {
  isNew?: boolean | null;
  isUpdated?: boolean | null;
  isComingSoon?: boolean | null;
  comingSoonAt?: string | null;
  newLabelPosition?: string | null;
  updatedLabelPosition?: string | null;
  comingSoonLabelPosition?: string | null;
}

export const createLabel = (text: string, position: string, isComingSoonLabel = false) => {
  const getPositionStyles = () => {
    switch (position) {
      case 'tr': return { top: '10px', right: '10px' }; // Top-right of image
      case 'bl': return { bottom: '20px', left: '10px' }; // Bottom-left, above progress/suggest bars
      case 'br': return { bottom: '20px', right: '10px' }; // Bottom-right, above progress/suggest bars
      default: return { top: '10px', right: '10px' }; // Default to top-right
    }
  };
  
  const positionStyles = getPositionStyles();
  
  return (
    <div 
      style={{
        ...positionStyles,
        display: 'flex',
        alignItems: 'center',
        backgroundImage: 'radial-gradient(farthest-corner at 10px 10px, #FFB073 0%, #AF77B8 100%)',
        position: 'absolute',
        height: '26px',
        margin: '0 auto',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: '500',
        color: 'white',
        borderRadius: '3px',
        padding: '0 10px',
        whiteSpace: 'nowrap',
        zIndex: 10
      }}
    >
      {text}
    </div>
  );
};

export const createContentLabel = (props: ContentLabelProps) => {
  const {
    isNew,
    isUpdated,
    isComingSoon,
    comingSoonAt,
    newLabelPosition,
    updatedLabelPosition,
    comingSoonLabelPosition
  } = props;

  // Normalize boolean values
  const normalizedIsNew = !!isNew;
  const normalizedIsUpdated = !!isUpdated;
  const normalizedIsComingSoon = !!isComingSoon;

  const getComingSoonDate = () => {
    if (normalizedIsComingSoon && comingSoonAt) {
      let d;
      if (comingSoonAt.includes('-')) {
        d = new Date('2023-09-23');
      } else {
        d = new Date(parseInt(comingSoonAt));
      }
      return formatDate(d.valueOf(), 'MMM dd, yyyy');
    }
    return '';
  };

  if (normalizedIsNew) {
    return createLabel('NEW', newLabelPosition || 'tr');
  } else if (normalizedIsUpdated) {
    return createLabel('UPDATED', updatedLabelPosition || 'tr');
  } else if (normalizedIsComingSoon) {
    const comingSoonDate = getComingSoonDate();
    return createLabel(`COMING SOON ${comingSoonDate}`, comingSoonLabelPosition || 'tr', true);
  }
  
  return null;
};
